import React from 'react';
import { Skeleton } from 'antd';
import styled from 'styled-components';

import useWindowSize from 'app/hooks/useWindowSize';

const TicketSkeleton: React.FC = () => {
  const { device } = useWindowSize();
  const isDesktop = device === 'desktop';

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: isDesktop ? 'row' : 'column',
      }}
    >
      <div
        style={{
          width: isDesktop ? 310 : '100%',
          height: 267,
          marginRight: isDesktop ? 16 : 0,
          flexShrink: 0,
        }}
      >
        <ImgSkeleton active shape="square" />
      </div>
      <div style={{ width: '100%', marginTop: isDesktop ? 0 : 16 }}>
        <InfoSkeleton active />
      </div>
    </div>
  );
};

export default TicketSkeleton;

const ImgSkeleton = styled(Skeleton.Avatar)`
  height: 100%;
  width: 100%;
  .ant-skeleton-avatar {
    height: 100%;
    width: 100%;
    border-radius: 16px;
  }
`;

const InfoSkeleton = styled(Skeleton)`
  .ant-skeleton-title {
    height: 26px;
  }
  .ant-skeleton-paragraph > li {
    height: 22px;
  }
`;
